<template>

  <!-- the messaging module works on full height columns, so it needs a box of
  its own inside the candidate tabs -->
  <div
    v-if="candidateId"
    class="candidate-messaging border rounded overflow-hidden">
    <Messaging
      :candidate-id="candidateId"
      :candidate-name="candidateName"
      :contacts="contacts" />
  </div>

</template>

<script>
import Messaging from '@/components/Messaging/Messaging'

export default {
  name: 'CandidateMessaging',
  components: {
    Messaging
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    candidateId () {
      return this.candidate ? this.candidate._id : null
    },
    candidateName () {
      return (this.candidate && this.candidate.name) || ''
    },
    /*
    contacts
    the candidate phones offered as shortcuts on the new conversation form.
    they are plain strings on the candidate, so the channel is assumed here
    */
    contacts () {
      const phones = (this.candidate && this.candidate.phones) || []

      return phones
      .filter((phone) => { return !!phone })
      .map((phone) => {
        return {
          type: 'whatsapp',
          contact_address: phone
        }
      })
    }
  }
}
</script>

<style scoped>
.candidate-messaging {
  height: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Messaging/CandidateMessaging.vue